import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';
import { useConsent } from '../contexts/ConsentContext';

/**
 * Custom hook to track page views using analytics service
 */
export const usePageTracking = (): void => {
    const location = useLocation();
    const { consent } = useConsent();

    useEffect(() => {
        // Only track page views if analytics consent is given
        if (consent.analytics) {
            // Get page title from document or use location path as fallback
            const pageTitle = document.title || location.pathname;

            // Track the page view
            trackPageView(
                {
                    path: location.pathname + location.search,
                    title: pageTitle
                },
                consent
            );
        }
    }, [location, consent]);
};
